import { createContext, RefObject, useContext } from "react";

export interface ModalProps {
	close: () => void;
}

export interface ModalConfig {
	closeOnBackdropClick?: boolean;
	closeOnLocationChange?: boolean;
	onBackdropClick?: () => void;
}

export type ModalRenderer = (close: () => void) => React.ReactElement;

interface ModalTools {
	createModal: (renderer: ModalRenderer, config?: ModalConfig) => void;
	backdropRef: RefObject<HTMLDivElement | null>;
	activeModalsCount: number;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ModalContext = createContext<ModalTools>(null as any);

export const useModalTools = (): ModalTools => useContext(ModalContext);
